import classNames from "classnames";
import React from "react";
import { typeIconMap } from "./utils";

interface Props {
  type: server.dto.AppointmentTypes
  onToggled: (type: server.dto.AppointmentTypes) => void
  isToggled: boolean
}

const AppointmentTypeFilter = (props: Props) => {
  const className = classNames(typeIconMap[props.type], {
    s1_transparent: !props.isToggled
  });

  return <div style={{ marginLeft: 5, display: "inline-block" }}>
    <a className={className} onClick={() => { props.onToggled(props.type); }}></a>
  </div>;
};

export default AppointmentTypeFilter;